module.exports = __webpack_public_path__ + "static/pic08-b6ad62759270596112bb862017365c1a.jpg";